import ProjectApi from "../api/project";

const CREATING_PROJECT = "CREATING_PROJECT",
  CREATING_PROJECT_SUCCESS = "CREATING_PROJECT_SUCCESS",
  CREATING_PROJECT_ERROR = "CREATING_PROJECT_ERROR",
  UPDATING_PROJECT = "UPDATING_PROJECT",
  UPDATING_PROJECT_SUCCESS = "UPDATING_PROJECT_SUCCESS",
  UPDATING_PROJECT_ERROR = "UPDATING_PROJECT_ERROR",
  DELETING_PROJECT = "DELETING_PROJECT",
  DELETING_PROJECT_SUCCESS = "DELETING_PROJECT_SUCCESS",
  DELETING_PROJECT_ERROR = "DELETING_PROJECT_ERROR",
  FETCHING_PROJECTS = "FETCHING_PROJECTS",
  FETCHING_PROJECTS_SUCCESS = "FETCHING_PROJECTS_SUCCESS",
  FETCHING_PROJECTS_ERROR = "FETCHING_PROJECTS_ERROR",
  FETCHING_PACK_AKENEO = "FETCHING_PACK_AKENEO",
  FETCHING_PACK_AKENEO_SUCCESS = "FETCHING_PACK_AKENEO_SUCCESS",
  FETCHING_PACK_AKENEO_ERROR = "FETCHING_PACK_AKENEO_ERROR",
  FETCHING_EVENT = "FETCHING_EVENT",
  FETCHING_EVENT_SUCCESS = "FETCHING_EVENT_SUCCESS",
  FETCHING_EVENT_ERROR = "FETCHING_EVENT_ERROR",
  FETCHING_STEPS = "FETCHING_STEPS",
  FETCHING_STEPS_SUCCESS = "FETCHING_STEPS_SUCCESS",
  FETCHING_STEPS_ERROR = "FETCHING_STEPS_ERROR",
  FETCHING_PROJECT = "FETCHING_PROJECT",
  FETCHING_PROJECT_SUCCESS = "FETCHING_PROJECT_SUCCESS",
  FETCHING_PROJECT_ERROR = "FETCHING_PROJECT_ERROR";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    entities: [],
    selectedEntity: null,
    fields: null,
    steps: null
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    hasError(state) {
      return state.error !== null;
    },
    error(state) {
      return state.error;
    },
    hasProjects(state) {
      return state.entities.length > 0;
    },
    projects(state) {
      return state.entities;
    },
    entity(state) {
      return state.selectedEntity;
    },
    fields(state) {
      return state.fields;
    },
    steps(state) {
      return state.steps;
    }
  },
  mutations: {
    [CREATING_PROJECT](state) {
      state.isLoading = true;
      state.error = null;
    },
    [CREATING_PROJECT_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
      state.entities.unshift(entity);
    },
    [CREATING_PROJECT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.entities = [];
    },
    [UPDATING_PROJECT](state) {
      state.isLoading = true;
      state.error = null;
    },
    [UPDATING_PROJECT_SUCCESS](state) {
      state.isLoading = false;
      state.error = null;
      // state.selectedEntity = entity;
    },
    [UPDATING_PROJECT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
    [DELETING_PROJECT](state) {
        state.isLoading = true;
        state.error = null;
    },
    [DELETING_PROJECT_SUCCESS](state, entity) {
        state.isLoading = false;
        state.error = null;
    },
    [DELETING_PROJECT_ERROR](state, error) {
        state.isLoading = false;
        state.error = error;
    },
    [FETCHING_PROJECTS](state) {
      state.isLoading = true;
      state.error = null;
      state.entities = [];
    },
    [FETCHING_PROJECTS_SUCCESS](state, entities) {
      state.isLoading = false;
      state.error = null;
      state.entities = entities;
    },
    [FETCHING_PROJECTS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.entities = [];
    },
    [FETCHING_PACK_AKENEO](state) {
        state.isLoading = false;
        state.error = null;
    },
    [FETCHING_PACK_AKENEO_SUCCESS](state, entity) {
        state.error = null;
        state.isLoading = false;
    },
    [FETCHING_PACK_AKENEO_ERROR](state, error) {
        state.isLoading = false;
        state.error = error;
    },
    [FETCHING_EVENT](state) {
      state.isLoading = false;
      state.error = null;
    },
    [FETCHING_EVENT_SUCCESS](state, entities) {
      state.isLoading = false;
      state.error = null;
    },
    [FETCHING_EVENT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [FETCHING_PROJECT](state) {
      state.isLoading = true;
      state.error = null;
      state.selectedEntity = null;
    },
    [FETCHING_PROJECT_SUCCESS](state, entity) {
      state.error = null;
      state.selectedEntity = entity;
      state.isLoading = false;
    },
    [FETCHING_PROJECT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
    [FETCHING_STEPS](state) {
      state.isLoading = true;
      state.error = null;
      state.steps = null;
    },
    [FETCHING_STEPS_SUCCESS](state, entity) {
      state.error = null;
      state.steps = entity;
      state.isLoading = false;
    },
    [FETCHING_STEPS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.steps = null;
    },
  },
  actions: {
    async findAll({ commit }) {
      commit(FETCHING_PROJECTS);
      try {
        let response = await ProjectApi.findAll();
        commit(FETCHING_PROJECTS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PROJECTS_ERROR, error);
        return null;
      }
    },
    async find({ commit }, id) {
      commit(FETCHING_PROJECT);
      try {
        let response = await ProjectApi.find(id);
        commit(FETCHING_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PROJECT_ERROR, error);
        return null;
      }
    },
    async create({ commit }, params) {
      commit(CREATING_PROJECT);
      try {
        let response = await ProjectApi.create(params);
        if (response.isAxiosError) {
          throw response;
        }
        commit(CREATING_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(CREATING_PROJECT_ERROR, error);
        return null;
      }
    },
    async findAkeneo({ commit }, sku) {
        commit(FETCHING_PACK_AKENEO);
        try {
            let response = await ProjectApi.findAkeneo(sku);
            commit(FETCHING_PACK_AKENEO_SUCCESS, response.data);
            return response.data;
        } catch (error) {
            commit(FETCHING_PACK_AKENEO_ERROR, error);
            return null;
        }
    },
    async findProject({ commit }, id) {
      commit(FETCHING_EVENT);
      try {
        let response = await ProjectApi.findProject(id);
        commit(FETCHING_EVENT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_EVENT_ERROR, error);
        return null;
      }
    },
    async create_nwf({ commit }, params) {
      commit(CREATING_PROJECT);
      try {
        let response = await ProjectApi.create_nwf(params);
        if (response.isAxiosError) {
          throw response;
        }
        commit(CREATING_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(CREATING_PROJECT_ERROR, error);
        return null;
      }
    },
    async update({ commit }, params) {
      commit(UPDATING_PROJECT);
      try {
        let response = await ProjectApi.update(params);
        commit(UPDATING_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(UPDATING_PROJECT_ERROR, error);
        return null;
      }
    },
    async delete({ commit }, id) {
        commit(DELETING_PROJECT);
        try {
            let response = await ProjectApi.delete(id);
            commit(DELETING_PROJECT_SUCCESS, response.data);
            return response.data;
        } catch (error) {
            commit(DELETING_PROJECT_ERROR, error);
            return null;
        }
    },
    async getSteps({ commit }, { id = null, mixed = false, fields = false }) {
      commit(FETCHING_STEPS);
      try {
        let response = (mixed) ?
          await ProjectApi.getMixedSteps(id) :
            (fields) ? await ProjectApi.fields() :
            await ProjectApi.getSteps(id);
        commit(FETCHING_STEPS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_STEPS_ERROR, error);
        return null;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/project.js